import { Container, ContainerProps } from '@mui/material'
export interface MolsonContainerProps extends ContainerProps {
  dataTestId?: string
}

export const MolsonContainer = ({
  dataTestId,
  children,
  ...props
}: MolsonContainerProps) => {
  return (
    <Container data-testid={dataTestId} {...props}>
      {children}
    </Container>
  )
}
